import { Directive, HostBinding, Input } from '@angular/core';
import { FlexElementDirective } from './flex-element.directive';
import { TBoxAlign, TBoxAxesAlignExpression, TBoxAxesArgs } from './model';

@Directive({
  selector: '[layout-align]',
  standalone: true
})
export class FlexLayoutAlignDirective<
  MainAxis extends TBoxAlign,
  CrossAxis extends TBoxAlign
> extends FlexElementDirective {
  @Input('layout-align')
  set layoutAlign(value: TBoxAxesAlignExpression<MainAxis, CrossAxis>) {
    const boxAxes = this.matchAlignmentPattern(value);

    const { mainAxis, crossAxis } = boxAxes;

    this.mainAxis = mainAxis;
    this.crossAxis = crossAxis;
  }

  @HostBinding(`style.justify-content`)
  private mainAxis: TBoxAlign;

  @HostBinding(`style.align-items`)
  private crossAxis: TBoxAlign;

  constructor() {
    super();
  }

  private matchAlignmentPattern(input: TBoxAxesAlignExpression<MainAxis, CrossAxis>): TBoxAxesArgs {
    const [mainAxis, crossAxis] = input.split(' ');

    if (!(mainAxis as TBoxAlign) || !(crossAxis as TBoxAlign)) {
      return { mainAxis: undefined, crossAxis: undefined };
    }

    return { mainAxis: mainAxis as TBoxAlign, crossAxis: crossAxis as TBoxAlign };
  }
}
